import React from 'react';
import { faSort, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';

import Button from 'components/buttons/button';
import AppModal from 'components/modal/appModal';
import { SocialMediaInput } from './socialMediaInput/SocialMediaInput';
import { getPositionOfButtons } from './SocialMediaForm.utils';
import { SocialMediaFormProps, SocialMediaFormState } from './SocialMediaForm.types';
import styles from './SocialMediaForm.module.scss';
import formStyles from 'components/form/appForm.module.scss';
import { OperationType } from 'components/portals/PortalsPage.utils';

export class SocialMediaForm extends React.Component<SocialMediaFormProps, SocialMediaFormState> {
  state = {
    error: '',
  };

  handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const { onSubmit, socialMediaButtons, initialSocialMediaButtons } = this.props;
    e.preventDefault();
    const initialPosition = getPositionOfButtons(initialSocialMediaButtons);
    const positionAfterSubmit = getPositionOfButtons(socialMediaButtons);

    if (isEqual(initialPosition, positionAfterSubmit)) {
      this.setState({
        error: 'At least one position of social media button is required to change to submit the form.',
      });

      return;
    }
    const valuesToSubmit = socialMediaButtons.map(socialMediaButton => ({
      id: socialMediaButton.id,
      order: socialMediaButton.order,
    }));

    onSubmit(valuesToSubmit);
  };

  handleOnSocialButtonMove = (e: React.MouseEvent<HTMLButtonElement>, id: string, type: OperationType) => {
    e.preventDefault();
    const { onSocialButtonMove } = this.props;
    onSocialButtonMove(id, type);
    this.setState({ error: '' });
  };

  render() {
    const { error } = this.state;
    const { form, socialMediaButtons } = this.props;
    const errorStyles = classNames([formStyles.error, styles.error]);

    return (
      <AppModal
        title="Order of social media buttons"
        id={form}
        form={form}
        buttonIcon={faSort}
        onClosed={() => this.setState({ error: '' })}
      >
        <form id={form} className={formStyles.appForm} onSubmit={this.handleOnSubmit}>
          {error && <p className={errorStyles}>{error}</p>}
          {socialMediaButtons.map(socialMediaButton => (
            <div key={socialMediaButton.id} className={styles.container}>
              <SocialMediaInput name={socialMediaButton.displayName} value={socialMediaButton.displayName} disabled />
              <div className={styles.buttonContainer}>
                <Button
                  text={null}
                  icon={faArrowUp}
                  slimButton
                  className={styles.button}
                  onClick={e => this.handleOnSocialButtonMove(e, socialMediaButton.id, 'increment')}
                />
                <Button
                  text={null}
                  icon={faArrowDown}
                  slimButton
                  className={styles.button}
                  onClick={e => this.handleOnSocialButtonMove(e, socialMediaButton.id, 'decrement')}
                />
              </div>
            </div>
          ))}
        </form>
      </AppModal>
    );
  }
}
